export const orderHistoryPath = (productId: number): string =>
  `api/v1/sale/product/${productId}/`

export const productPath = (productId: number): string =>
  `api/v1/product/v2/${productId}/`

export const DEFAULT_PRODUCT_FEATURES = ['attributes', 'variants', 'prices', 'stock', 'premium_bundles', 'discount_bundles']

export const productPriceTiersPath = (productId: number): string =>
  `api/v1/product/v2/${productId}/price-tiers/`

export const searchPath = (): string =>
  'api/v1/search/'

export const productListPath = (): string =>
  'api/v1/product/v2/list/'

export const PRODUCT_LIST_FEATURES = ['stock', 'prices']

export const productAlternativesPath = (productId: number): string =>
  `api/v1/product/v2/${productId}/alternatives/`

export const productRelatedPath = (productId: number): string =>
  `api/v1/product/v2/${productId}/related/`

export const productSimilarPath = (productId: number): string =>
  `api/v1/product/v2/${productId}/similar/`

export const productRecommendationsPath = (productId: number): string =>
  `api/v1/product/v2/${productId}/recommendations`

export const notifyStockAvailablePath = (productId: number): string =>
  `stock/notify_stock_available/${productId}/`
